/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {useIntl} from 'react-intl'
import {AnimaBaixo2} from '../../../../../../_metronic/assets/animation/styles'
import {LicenseTypesListWrapper} from '../../../../sga/license_types/components/license_types-list/LicenseTypesList'
import {PricingTableListWrapper} from '../../../../sga/pricing_table/components/PricingTableList/PricingTableList'
import {FormIssueOrgansEdit} from '../../components/formIssueOrgansEdit/FormIssueOrgansEdit'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {TableCostLicences} from '../../../costLicenses'

const EditIssueOrgans: FC = () => {
  const intl = useIntl()
  return (
    <>
      <AnimaBaixo2>
        <br />
        <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
        <PageTitle breadcrumbs={[]}>
          {intl.formatMessage({id: 'ISSUE_ORGANS.EDIT_ISSUE_ORGANS'})}
        </PageTitle>

        <div className='card mb-3 mt-n10'>
          <div className='card-header justify-content-start d-flex align-items-center'>
            <ul className='nav'>
              <li className='nav-item me-5'>
                <a
                  className='btn btn-text-gray-600 btn-active-light-primary fs-7 active'
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_1'
                >
                  {intl.formatMessage({id: 'ISSUE_ORGANS.TITLE'})}
                </a>
              </li>
              <li className='nav-item me-5'>
                <a
                  className='btn btn-text-gray-600 btn-active-light-primary fs-7'
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_2'
                >
                  {intl.formatMessage({id: 'LICENSE_TYPES.TITLE'})}
                </a>
              </li>
              <li className='nav-item me-5'>
                <a
                  className='btn btn-text-gray-600 btn-active-light-primary fs-7'
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_3'
                >
                  Tabela de Preços
                </a>
              </li>
              <li className='nav-item me-5'>
                <a
                  className='btn btn-text-gray-600 btn-active-light-primary fs-7'
                  data-bs-toggle='tab'
                  href='#kt_tab_pane_4'
                >
                  Custo de Licença
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className='tab-content mt-10' id='myTabContent'>
          <div className='tab-pane fade active show' id='kt_tab_pane_1' role='tabpanel'>
            <FormIssueOrgansEdit />
          </div>
          <div className='tab-pane fade mt-n8' id='kt_tab_pane_2' role='tabpanel'>
            <LicenseTypesListWrapper />
          </div>
          <div className='tab-pane fade mt-n8' id='kt_tab_pane_3' role='tabpanel'>
            <PricingTableListWrapper />
          </div>
          {/* <div className='tab-pane fade mt-n8' id='kt_tab_pane_4' role='tabpanel'>
            <TableCostLicences />
          </div> */}
        </div>
      </AnimaBaixo2>
    </>
  )
}

export {EditIssueOrgans}
